import React from "react";
import "./Tools.scss";
import Tjson from "./Json";

const Tools = () => {

 

  return (
    <section className="tools-section">
      {Tjson.map((item) => (
        <div className="tool-card" key={item.id}>
          <h2 className="tool-title">{item.title}</h2>
          <p className="tool-desc">{item.desc}</p>
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="tool-link"
          >
            Go to {item.goto}
          </a>
        </div>
      ))}
    </section>
  );
};

export default Tools;
